import React from "react";
import { Zap } from "lucide-react";
import { PARTNERS } from "../mock";

export default function Marquee() {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <div className="relative overflow-hidden border-y border-[#2fd645]/15 bg-[#0b0f0d] py-4">
      <div className="flex w-max id-marquee gap-10">
        {items.map((p, i) => (
          <div key={`${p}-${i}`} className="flex items-center gap-3 shrink-0">
            <Zap className="h-4 w-4 text-[#2fd645]" />
            <span className="text-sm font-semibold uppercase tracking-widest text-white/55">
              {p}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
